import React from 'react';
import { Line, LineChart, ResponsiveContainer } from 'recharts';

import colors from '@atom/styles/colors';
import { ConversationalAnalyticsChartProps } from '@atom/types/conversationalAnalytics';
import {
  CHART_HEIGHT,
  CHART_MARGINS,
} from '@atom/utilities/conversationalAnalyticsUtilities';

import useConversationalAnalyticsData from './hooks/useConversationalAnalyticsData';
import ConversationalAnalyticsChartAxes from './ConversationalAnalyticsChartAxes';
import ConversationalAnalyticsChartWrapper from './ConversationalAnalyticsChartWrapper';

const ConversationalAnalyticsTickChart: React.FC<
  ConversationalAnalyticsChartProps
> = ({ spec, width = '100%', height, onExport }) => {
  const { chartData, yField } = useConversationalAnalyticsData(spec);

  return (
    <ConversationalAnalyticsChartWrapper spec={spec} onExport={onExport}>
      <ResponsiveContainer width={width} height={height || CHART_HEIGHT}>
        <LineChart data={chartData} margin={CHART_MARGINS}>
          <ConversationalAnalyticsChartAxes spec={spec} />
          <Line
            type="linear"
            dataKey={yField}
            stroke={colors.brand.blue}
            strokeWidth={3}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </ConversationalAnalyticsChartWrapper>
  );
};

export default ConversationalAnalyticsTickChart;
